// Page Header
export const pageHeader = {
  title: "Strains",
  isEditorView: true,
  cancelPath: "strains",
  addPath: "strainEditor",
  buttonLabel: "Save",
};

// Page Header
export const listPageHeader = {
  title: "Strains",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "strainEditor",
};

export const filterCriteria = [
    {
        label: "Name",
        code: "name",
        numCharsToSearch: 3,
        field: { type: "input", label: "name" },
        isPartial: true,
    },
    {
        label: "State Id",
        code: "metrcStrainId",
        numCharsToSearch: 3,
        field: { type: "input", label: "state id" },
        isPartial: true,
    },
    { label: "Id", code: "_id", field: { type: "input", label: "Id" } },
];

export const columnHeaders = [
    {
        id: "open",
        type: "button",
        action: "navigateToEntity",
        iconName: "folder-open",
        ariaLabel: "Open",
    },
    {
        title: "Archived",
        id: "isArchived",
        type: "checkbox",
    },
    {
        title: "Name",
        id: "name",
        size: "large",
    },
    {
        title: "THC Level",
        id: "thcLevel",
        size: "large",
    },
    {
        title: "CBD Level",
        id: "cbdLevel",
        size: "large",
    },
    {
        title: "Indica %",
        id: "indicaPercentage",
        size: "large",
    },
    {
        title: "Sativa %",
        id: "sativaPercentage",
        size: "large",
    },
    {
        title: "State Id",
        id: "metrcStrainId",
    },
    {
        title: "Id",
        id: "_id",
    },
];

export const searchColumnHeaders = [
    {
        id: "select",
        type: "button",
        action: "selectItem",
        position: "sticky",
        iconName: "hand-pointer",
        ariaLabel: "Open",
    },
    {
        title: "Archived",
        id: "isArchived",
        type: "checkbox",
    },
    {
        title: "State Id",
        id: "metrcStrainId",
    },
    {
        title: "Name",
        id: "name",
    },
    {
        title: "THC Level",
        id: "thcLevel",
    },
    {
        title: "CBD Level",
        id: "cbdLevel",
    },
    {
        title: "Indica %",
        id: "indicaPercentage",
    },
    {
        title: "Sativa %",
        id: "sativaPercentage",
    },
    {
        title: "Id",
        id: "_id",
    },
];

// Strain Information - Main Section
export const strainInputs = [
  {
    id: 1,
    inputs: [
        {
          title: "Name",
          id: "name",
          placeholder: "Name",
          type: "input",
          required: true,
          focus: true,
          class: "grid-row-two-column",
        },
        {
          title: "Traceability System",
          id: "traceabilitySystem",
          placeholder: "Traceability System",
          class: "capitalize",
        },
        {
            title: "State Id",
            id: "metrcStrainId",
            placeholder: "State Id",
        },
        {
            title: "Testing Status",
            id: "testingStatus",
            placeholder: "Testing Status",
            type: "input",
            focus: true,
            class: "grid-row-two-column",
        },
        {
            id: "thcLevel",
            type: "number",
            title: "THC Level",
            precision: 4,
            placeholder: "THC Level",
        },
        {
            id: "cbdLevel",
            type: "number",
            title: "CBD Level",
            precision: 4,
            placeholder: "CBD Level",
        },
        {
            id: "indicaPercentage",
            type: "number",
            title: "Indica %",
            precision: 4,
            placeholder: "Indica %",
        },
        {
            id: "sativaPercentage",
            type: "number",
            title: "Sativa %",
            precision: 4,
            placeholder: "Sativa %",
        },
        {
            title: "Genetics",
            id: "genetics",
            placeholder: "Genetics",
            type: "input",
            focus: true,
            class: "grid-row-two-column",
        },
        {
            title: "Archived",
            id: "isArchived",
            placeholder: "Archived",
            type: "checkBox",
        },
    ],
  },
];

export const defaultSelectedStrain = {
    _id: "NEW",
    name: "",
    testingStatus: "",
    thcLevel: 0,
    cbdLevel: 0,
    indicaPercentage: 0,
    sativaPercentage: 0,
    genetics: "",
    isArchived: false,
};